import { forwardRef, useImperativeHandle } from 'react';

const QuestionFileUpload = forwardRef((props, ref) => {

    return (<></>);
});

export default QuestionFileUpload;